import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";
import Error from "next/error";

interface GoodsFilter {
	dspNm: string;
	lvl4List: string;
	monList: string;
	wdayList: string;
	outDeprtFgList: string;
	outCityList: string;
	evNightList: string;
	minPrice: string;
	maxPrice: string;
	airList: string;
	featuresList: string;
	tmemberList: string;
	promotionList: string;
	singleTypeCd: string;
}

/** ```
 * 상품 필터 정보
 *   `/pkg/goods/by-menu/${dspSid}/filter`
 * parameter
 * ```*/
const key = "useGoodsFilter";
const getPath = (dspSid: string): string | null =>
	`${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/goods/by-menu/${dspSid}/filter`;

/** ```
 * 상품 필터 정보 SSR
 *   `/pkg/goods/by-menu/${dspSid}/filter`
 * parameter
 * ```*/
const goodsFilterSSR = (dspSid: string) =>
	useConfigureAxios(getPath(dspSid), {
		method: "GET",
	});

/** ```
 * 상품 필터 정보
 *   `/prdt/api/filter/${dspSid}`
 * parameter
 * ```*/

const useGoodsFilter = (dspSid: string, options?: Partial<UseQueryOptions<Response<GoodsFilter>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(dspSid)],
		queryFn: () => useConfigureAxios({url: getPath(dspSid)}).then(r => r.data),
		...options,
	});

export default useGoodsFilter;
export {getPath, goodsFilterSSR};
export type {GoodsFilter};
